// extracted by mini-css-extract-plugin
module.exports = {"features-page-container":"features_features-page-container__2rgUn"};